module.exports = __webpack_public_path__ + "static/el_jefe-5783846e47ee57746b1eadc1cc54ed30.png";